
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/agent-faq/contact",
      function () {
        return require("private-next-pages/faq/agent-faq/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/agent-faq/contact"])
      });
    }
  